import Socket from '../connection/socket';
import {
	removeGraphicAction,
	updateGraphicsAction,
	loadGraphicsAction,
	prependGraphicAction,
} from '../stores/actions/graphics';
import { GraphicInterface } from '../stores/reducers/graphics';
import { GreenroomState } from '../stores/types/types';
import { getState, socketListenerDispatch } from './socket-listener-main';
import { showAlert } from '../components/general-components/alert-service';

interface GraphicSocketMessage {
	message: GraphicInterface | { id: string };
	type: string;
}

function handleSaveGraphicTrigger(socketMessage: GraphicSocketMessage) {
	const savedGraphic = socketMessage.message as GraphicInterface;

	socketListenerDispatch(prependGraphicAction(savedGraphic));
}

function handleEditGraphicTrigger(socketMessage: GraphicSocketMessage) {
	const editedGraphic = socketMessage.message as GraphicInterface;

	socketListenerDispatch(updateGraphicsAction(editedGraphic));
}

function handleDeleteGraphicTrigger(socketMessage: GraphicSocketMessage) {
	const { id: idString } = socketMessage.message as { id: string };
	const id = Number(idString);

	socketListenerDispatch(removeGraphicAction(id));
}

function handleLoadGraphicsTrigger() {
	const {
		SessionReducer: {
			token,
			meeting,
		},
	} = getState() as GreenroomState;
	if (token && meeting?.meeting) {
		socketListenerDispatch(loadGraphicsAction(token, meeting.meeting));
	}
}

function handleGraphicConvertError(message: any) {
	const {
		SessionReducer: {
			token,
			meeting,
			user,
		},
	} = getState() as GreenroomState;

	// show error toaster if you uploaded this graphic
	if (user && (user.gr_user === message.message)) {
		showAlert({
			message: 'File Upload Error',
			description: 'The file selected could not be uploaded',
			duration: 4000,
			type: 'error',
		});
	}

	// load graphics to remove the graphic that failed
	if (token && meeting?.meeting) {
		socketListenerDispatch(loadGraphicsAction(token, meeting.meeting));
	}
}

export default function Graphics(socket: Socket) {
	// is emitted when a new graphic is created
	socket.addListener('trigger-save-graphic', handleSaveGraphicTrigger);
	// is emitted when an existing graphic is edited
	socket.addListener('trigger-edit-graphic', handleEditGraphicTrigger);
	socket.addListener('trigger-delete-graphic', handleDeleteGraphicTrigger);
	// reloads all graphics for room - be wary of this
	socket.addListener('trigger-load-graphics', handleLoadGraphicsTrigger);
	socket.addListener('graphic-convert-error', handleGraphicConvertError);
}
